@if (client() && client()!.is_deleted && latestDeletionRequest()) {
  <div [attr.data-testid]="'deleted-client-message'">
    <p-message severity="error" icon="fa fa-trash" aria-label="deleted-client-message">
      <div class="flex flex-column gap-1">
        <div class="font-semibold">{{'CLIENT_PROFILE.DELETED_CLIENT_BANNER.TITLE' | translate}}</div>
        <div class="text-sm">
          <strong>{{'CLIENT_PROFILE.DELETED_CLIENT_BANNER.DELETED_ON' | translate}}:</strong>
          {{ latestDeletionRequest()!.status_update_date | date: 'medium' }}
        </div>
        @if (latestDeletionRequest()!.reason) {
          <div class="text-sm">
            <strong>{{'CLIENT_PROFILE.DELETED_CLIENT_BANNER.REASON' | translate}}:</strong>
            {{ latestDeletionRequest()!.reason }}
          </div>
        }
      </div>
    </p-message>
  </div>
}

@if (client() && client()!.is_blacklisted) {
  <div class="" [attr.data-testid]="'blacklisted-message'">
    <p-message severity="error" icon="fa fa-triangle-exclamation" aria-label="blacklisted-message">
      {{client()!.blacklisted_reason}}
    </p-message>
  </div>
}

@if (client() && client()!.is_irregular) {
  <div class="" [attr.data-testid]="'irregular-client-message'">
    <p-message severity="error" icon="fa fa-triangle-exclamation" aria-label="irregular-client-message">
      {{'CLIENT_PROFILE.IS_AT_RISK' | translate}}
    </p-message>
  </div>
}

<!-- Row -->
<div class="lg:flex" [attr.data-testid]="'client-profile-container'">

  <!-- Left Side -->
  <div class="lg:w-3 border-right-1 border-300" [ngClass]="currentTenantClient() ? 'surface-0' : 'bg-yellow-100'" [attr.data-testid]="'client-profile-left-side'">
    <fitness-force-client-profile-left-side [client]="client()!" [tenantId]="tenantId()" [showSkeleton$]="showSkeleton$" (closeClientSidebar)="closeSidebar($event)" (changeEvent)="changeEvent($event)" />
  </div>
  <!-- Left Side -->

  <!-- Right Side -->
  <div class="lg:w-9 md:pr-3 lg:pb-3 surface-200 z-1" [attr.data-testid]="'client-profile-right-side'">
    <p-tabs [value]="activeIndex().toString()" scrollable (valueChange)="onTabChange($event)">
      <p-tablist aria-labelledby="client-profile-tabs">
        @for (tab of clientOverviewTabs(); track tab.key; let i = $index) {
          <p-tab
            [value]="i.toString()"
            [attr.data-testid]="'tab-header-' + tab.title.toLowerCase()"
            [attr.aria-label]="tab.title.toLowerCase() + '-tab'"
            [attr.aria-controls]="'tab-content-' + i"
            class="flex align-items-center white-space-nowrap text-xs md:text-sm"
            [ngClass]="{'lg:hidden': tab.key === 'clientsummary'}">
            <i class="{{tab.icon}} mr-2" [attr.data-testid]="'tab-icon-' + tab.title.toLowerCase()"></i>
            <span [attr.data-testid]="'tab-title-' + tab.title.toLowerCase()" [attr.id]="'tab-label-' + i">{{'CLIENT_PROFILE.TABS.'+tab.title | translate}}</span>
          </p-tab>
        }
      </p-tablist>
      <p-tabpanels>
        @for (tab of clientOverviewTabs(); track tab.key; let i = $index) {
          <p-tabpanel
            [value]="i.toString()"
            [attr.aria-label]="tab.key + '-panel'"
            [attr.id]="'tab-content-' + i"
            [attr.aria-labelledby]="'tab-label-' + i">
            @if (activeIndex() === i && clientId()) {
              @switch (tab.key) {
                @case ('clientsummary') {
                  <div class="surface-100 lg:pb-8" [attr.data-testid]="'client-summary-tab-content'">
                    <fitness-force-client-profile-details-tab [showSkeleton$]="showSkeleton$" [client]="client()!" [tenantId]="tenantId()" />
                  </div>
                }
                @case ('overview') {
                  <div class="surface-100 lg:pb-8" [attr.data-testid]="'overview-tab-content'">
                    <fitness-force-client-overview-tab [showSkeleton$]="showSkeleton$" [clientInteractions$]="clientInteractions$" [client]="client()!" [clientId]="clientId()"
                      (changeTab)="changeTabClick($event)" [clickfromTab]="clickfromTab$" [tenantId]="tenantId()" [clientReferrals$]="clientReferrals$" [clientOffers$]="clientCoupons$"
                      (reloadData)="reloadData()" [interactionId]="interactionId()" [height]="overViewHeight()" />
                  </div>
                }
                @case ('activity_feed') {
                  <div class="flex flex-column h-full surface-100 p-3" [attr.data-testid]="'activity-feed-tab-content'">
                    <client-interaction-tab [clientId]="clientId()" [interactions]="clientInteractions$" [showSkeleton]="showSkeleton$" [clickFromTab]="clickfromTab$" [showMax]="0" [showCollapsed]="showCollapsed$" [clientDetails]="client()!"
                      [height]="'100%'" [interactionId]="interactionId()" />
                  </div>
                }
                @case ('booking') {
                  <div class="lg:h-screen overflow-y-auto surface-100 lg:pb-8" [attr.data-testid]="'booking-tab-content'">
                    <client-booking-tab [clientId]="clientId()" [client]="client()" />
                  </div>
                }
                @case ('subscriptions') {
                  <div class="lg:h-screen overflow-y-auto surface-100 lg:pb-8" [attr.data-testid]="'subscriptions-tab-content'">
                    <subscription-list [clientId]="clientId()" [client]="client()!" />
                  </div>
                }
                @case ('transactions') {
                  <div class="lg:h-screen overflow-y-auto surface-100 lg:pb-8" [attr.data-testid]="'transactions-tab-content'">
                    <transaction-tab [clientId]="clientId()" [activeSubTab]="activeSubTab()" (updateData)="updateData($event)" />
                  </div>
                }
                @case ('trial') {
                  <div class="lg:h-screen overflow-y-auto surface-100 lg:pb-8" [attr.data-testid]="'trial-tab-content'">
                    <client-trial-tab [clientId]="clientId()" />
                  </div>
                }
                @case ('task') {
                  <div class="lg:h-screen overflow-y-auto surface-100 lg:pb-8" [attr.data-testid]="'task-tab-content'">
                    <client-task-tab [clientId]="clientId()" />
                  </div>
                }
                @case ('check_in') {
                  <div class="lg:h-screen overflow-y-auto surface-100 lg:pb-8" [attr.data-testid]="'check-in-tab-content'">
                    <fitness-force-client-checkin-tab [clientId]="clientId()" [client]="client()!" />
                  </div>
                }
                @case ('forms') {
                  <div class="lg:h-screen overflow-y-auto surface-100 lg:pb-8" [attr.data-testid]="'forms-tab-content'">
                    <fitness-force-client-forms-tab [clientId]="clientId()" [tenantId]="tenantId()" />
                  </div>
                }
                @case ('milestones') {
                  <div class="lg:h-screen overflow-y-auto surface-100 lg:pb-8" [attr.data-testid]="'milestones-tab-content'">
                    <app-client-milestone-tab [clientId]="clientId()" [tenantId]="tenantId()" />
                  </div>
                }
                @case ('migration') {
                  <div class="lg:h-screen overflow-y-auto surface-100 lg:pb-8" [attr.data-testid]="'migration-tab-content'">
                    <client-migration-tab [clientId]="clientId()" />
                  </div>
                }
                @case ('fitness') {
                  @if (clientUuid()) {
                    <div class="lg:h-screen overflow-y-auto surface-100 lg:pb-8" [attr.data-testid]="'fitness-tab-content'">
                      <client-fitness-tab [client_uuid]="clientUuid()" />
                    </div>
                  }
                }
              }
            }
          </p-tabpanel>
        }
      </p-tabpanels>
  </p-tabs>
</div>
<!-- Right Side -->
</div>

<p-confirmDialog
  #tenantSwitchConfirm
  key="clientTenantSwitch"
  [style]="{ width: '28rem' }"
  [appendTo]="'body'"
  [baseZIndex]="10000"
  styleClass="tenant-switch-confirm-dialog"
  data-testid="tenant-switch-dialog"
  aria-label="tenant-switch-dialog"
>
  <ng-template pTemplate="message">
    <p class="m-0 text-sm line-height-3 text-700">
      {{ 'CLIENT_PROFILE.TENANT_SWITCH.MESSAGE_PREFIX' | translate }}
      <strong class="font-semibold text-900">{{ clientTenantName() }}</strong>.
      {{ 'CLIENT_PROFILE.TENANT_SWITCH.MESSAGE_SUFFIX' | translate }}
    </p>
  </ng-template>
  <ng-template pTemplate="footer">
    <div class="flex gap-2 justify-content-end w-full">
      <p-button
        [label]="'CLIENT_PROFILE.TENANT_SWITCH.CLOSE' | translate"
        severity="secondary"
        styleClass="text-sm"
        (onClick)="tenantSwitchConfirm.onReject()"
        aria-label="close-tenant-switch-dialog-button"
        data-testid="close-tenant-switch-button"
      />
      <p-button
        [label]="'CLIENT_PROFILE.TENANT_SWITCH.SWITCH' | translate"
        styleClass="text-sm"
        (onClick)="tenantSwitchConfirm.onAccept()"
        aria-label="switch-tenant-button"
        data-testid="switch-tenant-button"
      />
    </div>
  </ng-template>
</p-confirmDialog>
